export default "__VITE_ASSET__dead722f__"